import { useTranslation } from "react-i18next";
import { ContentContainer } from "~/components/common/content-container";
import BrokerSelecter from "~/components/mqtt/broker-select";
import { Input, Label } from "~/components/ui";
import { Switch } from "~/components/ui/switch";
import type { MqttBroker, SparkplugMetaDto } from "~/types/api";

export default function SparkplugFormField({
  value,
  onChange,
  options = [],
}: {
  value: SparkplugMetaDto;
  onChange: (val: SparkplugMetaDto) => void;
  options?: { label: string; value: MqttBroker }[];
}) {
  const { t } = useTranslation();

  return (
    <div className="ml-3">
      <ContentContainer>
        <div className="mb-2">
          <Label className="text-sm">{t("sparkplug.fields.broker")}</Label>
          <BrokerSelecter
            value={value?.brokerId ?? ""}
            onChange={(val) => {
              onChange({ ...value, brokerId: val });
            }}
            options={options.map((x) => x.value)}
            canCreate
          />
        </div>
        <div className="mb-2">
          <Label className="text-sm">{t("sparkplug.fields.edgeId")}</Label>
          <Input
            value={value.edgeId ?? ""}
            placeholder={t("sparkplug.placeholders.edgeId")}
            onChange={(e) => onChange({ ...value, edgeId: e.target.value })}
          />
        </div>
        <div className="mb-2">
          <Label className="text-sm">{t("sparkplug.fields.groupId")}</Label>
          <Input
            value={value.groupId ?? ""}
            placeholder={t("sparkplug.placeholders.groupId")}
            onChange={(e) => onChange({ ...value, groupId: e.target.value })}
          />
        </div>
        <div className="mb-2">
          <Label className="text-sm">
            {t("sparkplug.fields.useNameForPublish")}
          </Label>
          <Switch
            checked={value.useNameForPublish ?? true}
            onCheckedChange={(val) =>
              onChange({ ...value, useNameForPublish: val })
            }
          />
        </div>
      </ContentContainer>
    </div>
  );
}
